export const quotationStatusTypeDummyData = {
  id: "dummy",
  quotation_status_type_name_ch: "全部狀態",
  quotation_status_type_name_en: "All",
};
